export default __webpack_public_path__ + "static/media/16.385b8afc.jpg";